export default {"src":"/_next/static/media/account.67824c8b.svg","height":24,"width":24};